<template>
	<div class="ss-content volunteer-home-project-detail-content">
		<div class="activity-info">
			<div class="ss-container">
				<div class="activity-info__left">
					<img :src="articleData.attrs.listPic | imgUrl" />
					<div class="activity-info__num activity-info__num_big clearfix">
						<div class="activity-info__item">
							<span>计划招募</span>
							<span>{{articleData.attrs.registerLimit}} </span>
						</div>
						<div class="activity-info__item">
							<span>已招募</span>
							<span>{{ signCount }} </span>
						</div>
					</div>
					<div class="activity-info__btn">
						<button class="btn-primary btn-radius" @click="signUpClick" :style="{ backgroundColor: isSubscribe == '2' ? 'gray' : '', }" :disabled = "isSubscribe == '2'" >立即报名 </button>
					</div>
				</div>
				<div class="activity-info__right">
					<div class="activity-info__title">{{articleData.title}}</div>
					<div class="line-1 pb10">
						<div class="activity-info__time mt0">
							<p v-if="articleData.attrs">服务地点：{{articleData.attrs.place}}</p>
						</div>
					</div>
					<div class="activity-info__desc" v-if="articleData.contentExt">{{articleData.contentExt.description}}</div>
				</div>
			</div>
		</div>
		<div class="activity-detail-content ss-container">
			<div class="activity-detail__left ss-container__left">
				<ul class="activity-detail__menu">
					<li class="active">活动详情</li>
				</ul>
				<div class="activity-detail__tab">
					<div class="activity-detail__content activity-detail__content_active">
						<div class="article__html" v-html="articleData.txt"></div>
					</div>
				</div>
			</div>
			<div class="ss-container__right">
				<div class="gzh-box">
					<img class="poster-image" :src="rightTopData.qrCode | imgUrl" />
					<p>使用微信扫一扫打开小程序，<br/>可通过微信将该项目转发给好友</p>
				</div>
				<div class="mt50">
					<p class="ss-container__right_title">志愿者部</p>
					<div class="bumen-box">
						<div class="bumen-info">
							<img src="~@/assets/img/volunteerHome/shouji.png" />手机：{{rightTopData.mobile}}
						</div>
						<div class="bumen-info">
							<img src="~@/assets/img/volunteerHome/dianhua.png" />电话：{{rightTopData.telephone}}
						</div>
						<div class="bumen-info">
							<img src="~@/assets/img/volunteerHome/youxiang.png" class="youxiang" />邮箱：{{rightTopData.email}}
						</div>
						<div class="bumen-info">
							<img src="~@/assets/img/volunteerHome/dizhi.png" />地址：{{rightTopData.address}}
						</div>
					</div>
				</div>
				<div class="mt50">
					<p class="ss-container__right_title">近期志愿者项目公示</p>
					<ul class="gongshi-list">
						<li class="gongshi-item clearfix" v-for="(item, index) in activityOther" :key="index"  @click="goDetail(item.id)">
							<img :src="item.attrs.listPic | imgUrl" />
							<div class="gongshi__content">
								<p class="gongshi__title">{{item.title}}</p>
								<p class="gongshi__desc">{{item.attrs.place}}</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<ssActivityRegistration ref="regModal" :contentId="contentId" :notice="(articleData.attrs && articleData.attrs.notice || '')" />
	</div>
</template>

<script>
	import ssCommentList from '@/components/ss-comment-list/ss-comment-list.vue'
	import ssActivityRegistration from '@/components/ss-activity-registration/ss-activity-registration.vue'
	import articleDetailMixin from '@/mixins/articleDetail.js'
	export default {
		mixins: [ articleDetailMixin ],
		name: 'culturalActivityDetail',
		components: {
			ssCommentList,
			ssActivityRegistration
		},
		data() {
			return {
				signUpFlag: false,
				successFlag: false,
				noticeFlag: false,
				rightTopData: {}
			}
		},
		created() {
			this.volunteerProjQrCodeInfo();
		},
		methods: {
			goDetail(id) {
				this.$emit('onClick', id)
				if(!this.detailPath) return ;
				this.$router.push({
					path: this.detailPath + id
				})
			},
			signUpClick(status) {
				if(status >= 2) return
				this.$refs.regModal.show();
			},
			async volunteerProjQrCodeInfo() {
				let res = await this.$http('volunteerProjQrCodeInfo', {
					contentId: this.contentId
				});
				res.code === 1 && (this.rightTopData = res.data);
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	@import '~@/assets/css/activity-detail.scss';
	.volunteer-home-project-detail-content{
		padding-bottom: 70px;
		.gongshi-list{
			margin-top: 30px;
			padding: 0 13px;
			.gongshi-item{
				& + .gongshi-item{
					margin-top: 20px;
				}
				img{
					width: 60px;
					float: left;
				}
				.gongshi__content{
					padding-left: 20px;
					padding-top: 8px;
					width: 204px;
					float: right;
				}
				.gongshi__title{
					font-size:16px;
					font-weight:400;
					color:rgba(91,91,91,1);
					line-height:18px;
				}
				.gongshi__desc{
					margin-top: 12px;
					font-size:14px;
					font-weight:400;
					color:rgba(160,160,160,1);
					line-height:18px;
				}
			}
		}
		.bumen-box{
			margin-top: 30px;
			padding: 0 20px;
			.bumen-info{
				font-size:16px;
				font-weight:400;
				color:rgba(119,119,119,1);
				line-height:30px;
				padding-left: 27px;
				position: relative;
				img{
					@include abs(6px, null, null, 0);
					&.youxiang{
						top: 9px;
					}
				}
			}
		}
		.ss-container__right{
			background-color: #fff;
			border-top: 3px solid #0260FE;
			padding-bottom: 35px;
		}
		.gzh-box{
			padding: 40px 30px;
			text-align: center;
			img{
				width: 145px;
				height: 145px;
				display: block;
				margin: 0 auto;
			}
			p{
				font-size:16px;
				font-weight:400;
				color:rgba(148,148,148,1);
				line-height:22px;
				margin-top: 18px;
			}
		}
		.ss-container__right_title{
			font-size:18px;
			font-weight:400;
			color:rgba(34,34,42,1);
			line-height:40px;
			padding-left: 34px;
			position: relative;
			&::before{
				content: '';
				height: 40px;
				width: 5px;
				background-color: #0260FE;
				border-radius: 0 5px 5px 0;
				@include abs(0, null, null, 12px);
			}
		}
	}
</style>
